import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const s = auth.snapshot;

  // Must be logged in + 2FA verified
  if (!s.isLoggedIn || !s.isTwoFaVerified) {
    router.navigateByUrl('/login');
    return false;
  }

  // If user has >1 account and hasn't selected one yet, force Choose Account
  if (auth.requiresAccountSelection() && state.url !== '/choose-account') {
    router.navigateByUrl('/choose-account');
    return false;
  }

  return true;
};
